import { ProductDetailColorSelectionEvent } from '@/usecases/event-bus-for-third-party/events/product-detail'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { viewItemEventFactory } from '@/vendor/gtm/events/ga4/view-item'

/**
 * カラーが選択されたとき、そのSKUが閲覧されたとしてGA4のview_itemイベントを送信する
 * @see https://github.com/Everforth/growthpalette-front/issues/8606
 */
export function handleProductDetailColorSelectionEvent(event: ProductDetailColorSelectionEvent): void {
  const dataLayerService = new DataLayerService()
  const viewItemEvent = viewItemEventFactory.createFromProductDetailColorSelectionEvent(event)
  dataLayerService.push(viewItemEvent)
}
